import { Bell, BellOff, BellRing } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function NotificationToggle() {
  const { state, isWorking, enable, disable, sendTest } = usePushNotifications();

  if (state === 'unsupported') return null;

  const Icon = state === 'subscribed' ? BellRing : state === 'denied' ? BellOff : Bell;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Notifications" disabled={isWorking}>
          <Icon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Notifications push</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {state === 'denied' && (
          <DropdownMenuItem disabled className="text-muted-foreground text-xs">
            Bloquées par le navigateur. Active-les dans les réglages du site.
          </DropdownMenuItem>
        )}
        {(state === 'unknown' || state === 'unsubscribed') && (
          <DropdownMenuItem onSelect={() => enable()}>
            <Bell className="mr-2 h-4 w-4" />
            Activer les notifications
          </DropdownMenuItem>
        )}
        {state === 'subscribed' && (
          <>
            <DropdownMenuItem onSelect={() => sendTest()}>
              <BellRing className="mr-2 h-4 w-4" />
              Envoyer une notif test
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={() => disable()}>
              <BellOff className="mr-2 h-4 w-4" />
              Désactiver
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
